/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';

class FeedbackServiceService {
  async createFeedback(state, data) {
    const response = await api.post('/feedback', {}, data);
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new FeedbackServiceService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/feedback/services/FeedbackService/FeedbackServiceService.js